"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthorisationFieldEditor = exports.AuthorisationData = void 0;
const query_1 = require("./query");
class AuthorisationData {
    constructor() {
        this.AuthorisationText = '';
        this.WasAuthorised = false;
    }
}
exports.AuthorisationData = AuthorisationData;
class AuthorisationFieldEditor {
    constructor(container) {
        this.drawing = false;
        this.points = [];
        this.container = container;
        //return;
        query_1.Z.forEachFrom(container, 'input[data-subfield="value"]', el => {
            this.input = el;
        });
        query_1.Z.forEachFrom(container, 'canvas', el => {
            this.canvas = el;
            this.context = el.getContext('2d');
            this.context.strokeStyle = '#000000';
            this.context.lineWidth = 2;
            this.context.fillStyle = 'white';
            this.context.fillRect(0, 0, this.canvas.width, this.canvas.height);
            let saved = (this.canvas.dataset.signature + '').toString();
            if (saved && saved.startsWith('data:')) {
                let img = document.createElement('img');
                img.onload = ev => {
                    this.context.drawImage(img, 0, 0, this.canvas.width, this.canvas.height);
                };
                img.src = saved;
            }
            else {
                this.clearSignature();
            }
            this.canvas.addEventListener('touchstart', ev => this.touchStart(ev));
            this.canvas.addEventListener('touchmove', ev => this.touchMove(ev));
            this.canvas.addEventListener('touchend', ev => this.touchEnd(ev));
            this.canvas.addEventListener('mousedown', ev => this.mouseDown(ev));
            this.canvas.addEventListener('mousemove', ev => this.mouseMove(ev));
            this.canvas.addEventListener('mouseup', ev => this.mouseUp(ev));
            this.canvas.addEventListener('mouseout', ev => this.mouseOut(ev));
        });
        query_1.Z.forEachFrom(container, 'input[type="checkbox"]', el => {
            this.checkbox = el;
        });
        query_1.Z.forEachFrom(container, 'button[data-action="clear"]', el => {
            this.clearButton = el;
            this.clearButton.addEventListener('click', ev => this.clearSignature());
        });
        query_1.Z.forEachFrom(container, 'button[data-action="autofill"]', el => {
            this.autofillButton = el;
            this.autofillButton.addEventListener('click', ev => this.autofillSignature());
        });
        console.log(`authorisation field: `, this);
    }
    draw() {
        if (!this.points.length)
            return;
        if (this.points.length == 1)
            return;
        let first = this.points.shift();
        //let second = this.points.pop();
        let second = this.points[0];
        //this.context.beginPath();
        this.context.save();
        this.context.beginPath();
        this.context.fillStyle = 'black';
        this.context.strokeStyle = '#000000';
        this.context.lineWidth = 2;
        this.context.moveTo(first.x, first.y);
        this.context.lineTo(second.x, second.y);
        this.context.stroke();
        this.context.restore();
        //console.log(`draw from [${first.x}, ${first.y}] => [${second.x}, ${second.y}]`);
        //console.log(`draw ${this.points.length} points`);
    }
    clearSignature() {
        this.context.fillStyle = 'white';
        this.context.fillRect(0, 0, this.canvas.width, this.canvas.height);
        this.points = [];
        this.draw();
        this.drawing = false;
        this.updateSignature(true);
    }
    autofillSignature() {
        this.clearSignature();
        let prefill = `${this.canvas.dataset.prefill}`;
        this.context.font = '1cm handwriting';
        this.context.fillStyle = 'black';
        this.checkbox.checked = true;
        let measure = this.context.measureText(prefill);
        this.context.fillText(prefill, this.canvas.width / 2 - measure.width / 2, this.canvas.height / 2 - measure.fontBoundingBoxDescent / 2, this.canvas.width);
        this.drawing = false;
        this.updateSignature();
    }
    touchStart(ev) {
        //console.log(`touchstart`, ev);
        this.drawing = true;
        this.points.push({ x: ev.touches.item(0).clientX - this.canvas.getBoundingClientRect().left, y: ev.touches.item(0).clientY - this.canvas.getBoundingClientRect().top });
        ev.preventDefault();
        ev.stopPropagation();
        return false;
    }
    touchMove(ev) {
        //console.log(`touchmove`, ev);
        if (this.drawing) {
            this.points.push({ x: ev.touches.item(0).clientX - this.canvas.getBoundingClientRect().left, y: ev.touches.item(0).clientY - this.canvas.getBoundingClientRect().top });
            this.draw();
        }
        ev.preventDefault();
        ev.stopPropagation();
        return false;
    }
    touchEnd(ev) {
        //console.log(`touchend`, ev);
        this.drawing = false;
        ev.preventDefault();
        ev.stopPropagation();
        this.points = [];
        this.updateSignature();
        return false;
    }
    mouseDown(ev) {
        //console.log(`mousedown`, ev);
        this.drawing = true;
        this.points.push({ x: ev.offsetX, y: ev.offsetY });
        ev.preventDefault();
        ev.stopPropagation();
        return false;
    }
    mouseMove(ev) {
        if (this.drawing) {
            //console.log(`mousemove`, ev);
            this.points.push({ x: ev.offsetX, y: ev.offsetY });
            this.draw();
        }
        ev.preventDefault();
        ev.stopPropagation();
        return false;
    }
    mouseUp(ev) {
        //console.log(`mouseup`, ev);
        if (this.drawing) {
            this.drawing = false;
            this.points = [];
            this.updateSignature();
        }
        ev.preventDefault();
        ev.stopPropagation();
        return false;
    }
    mouseOut(ev) {
        if (this.drawing) {
            this.drawing = false;
            this.points = [];
            this.updateSignature();
        }
        ev.preventDefault();
        ev.stopPropagation();
        return false;
    }
    get value() {
        var data = new AuthorisationData();
        if (this.checkbox)
            data.WasAuthorised = this.checkbox.checked;
        if (this.canvas)
            data.Signature = this.canvas.toDataURL();
        if (data.WasAuthorised) {
            if (!data.AuthorisedOn)
                data.AuthorisedOn = new Date().toISOString();
            if (!data.AuthorisedByName)
                data.AuthorisedByName = this.input.dataset.uName;
            if (!data.AuthorisedUserId)
                data.AuthorisedUserId = this.input.dataset.uId;
        }
        else {
            data.AuthorisedByName = null;
            data.AuthorisedOn = null;
            data.AuthorisedUserId = null;
            data.Signature = null;
        }
        return data;
    }
    updateSignature(cleared = false) {
        //let fieldContainer = $(this.canvas).parentsUntil('.authorisation-field').parent();
        //let fieldInput = $(fieldContainer).find('input[type="hidden"]').first();
        /* let fieldValue = JSON.parse($(fieldInput).val().toString());
        if (cleared) {
            fieldValue.Signature = null;
        } else {
            fieldValue.Signature = this.canvas.toDataURL();
        }
        //console.log(`update signature: ${fieldValue.Signature}`);
        $(fieldInput).val(JSON.stringify(fieldValue)).change(); */
        if (this.input)
            this.input.value = JSON.stringify(this.value);
    }
    static init() {
        query_1.Z.init('.authorisation-field', 'authorisation-field', el => {
            return new AuthorisationFieldEditor(el);
        });
    }
}
exports.AuthorisationFieldEditor = AuthorisationFieldEditor;
//# sourceMappingURL=authorisationFieldEditor.js.map